import { Box, Typography } from "@mui/material";
import React from "react";

import GroupingTable from "../../../MCS3/BOMTab/DrawingBom/components/Tables/GroupingTable";
import MrqDetails from "../../../MCS3/BOMTab/MRQTab/components/MrqDetails";

export default function ChangeOrderModal({
  plant,
  mrqDetails,
  drawing,
  consolidatedMaterials,
  mrqMaterials,
  setMrqMaterials,
  type,
  onChangeDetails = () => {},
}) {
  const rev = drawing?.revision;

  console.log("rowssss:", mrqMaterials);
  return (
    <Box>
      {type === "revise" && (
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ mb: 2 }}
        >
          Update Change Order ({"CO-0" + (rev ? rev : 1)}) MRQ materials:
        </Typography>
      )}
      <Box>
        <GroupingTable
          consolidatedMaterials={consolidatedMaterials}
          mrqMaterials={mrqMaterials}
          setMrqMaterials={setMrqMaterials}
        />
      </Box>

      <Box sx={{ py: 2 }}>
        <MrqDetails
          plant={plant}
          mrq={mrqDetails}
          addCopyBtn={false}
          focusOnRev={type === "revise"}
          isEditMode={type === "add"}
          onChangeDetails={onChangeDetails}
        />
      </Box>
    </Box>
  );
}
